/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { AssetsAqlSearchInputSkeleton } from './aql-search-input/loading-state';
import { AssetsObjectSchemaSelectSkeleton } from './object-schema-select/loading-state';
import { FormContainer, FormRowContainer, SchemaSelectContainer } from './styled-old';
export var AssetsSearchContainerLoadingOld = function AssetsSearchContainerLoadingOld(_ref) {
  var modalTitle = _ref.modalTitle;
  return jsx(FormContainer, {
    "data-testid": "assets-datasource-modal--search-container-skeleton"
  }, jsx(FormRowContainer, {
    isNarrowGap: true
  }, modalTitle, jsx(SchemaSelectContainer, null, jsx(AssetsObjectSchemaSelectSkeleton, null))), jsx(FormRowContainer, null, jsx(AssetsAqlSearchInputSkeleton, null)));
};